// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/VideoProcessing.css */
.video-processing {
    max-width: 800px;
    margin: 0 auto;
    padding: 24px;
    background-color: var(--white);
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  
  .video-processing h2 {
    text-align: center;
    margin-bottom: 24px;
    color: var(--primary-color);
  }
  
  .progress-container {
    margin-bottom: 24px;
  }
  
  .progress-bar {
    height: 10px;
    background-color: var(--light-border);
    border-radius: 5px;
    overflow: hidden;
    margin-bottom: 8px;
  }
  
  .progress {
    height: 100%;
    background-color: var(--primary-color);
    transition: width 0.3s ease;
  }
  
  .progress-percentage {
    text-align: center;
    font-size: 14px;
    color: var(--light-text);
  }
  
  .processing-stages {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  
  .processing-stage {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border-radius: 8px;
    background-color: var(--background-color);
  }
  
  .processing-stage.completed {
    background-color: rgba(76, 175, 80, 0.1);
  }
  
  .processing-stage.current {
    background-color: var(--primary-light);
    border-left: 4px solid var(--primary-color);
  }
  
  .stage-indicator {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    font-size: 14px;
  }
  
  .processing-stage.completed .stage-indicator {
    background-color: var(--status-green);
    color: var(--white);
  }
  
  .processing-stage.current .stage-indicator {
    background-color: var(--primary-color);
    color: var(--white);
  }
  
  .stage-name {
    font-size: 16px;
    font-weight: 500;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/css/VideoProcessing.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,sCAAsC;IACtC,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,sCAAsC;IACtC,2CAA2C;EAC7C;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;;EAEA;IACE,sCAAsC;IACtC,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB","sourcesContent":["/* src/components/VideoProcessing.css */\n.video-processing {\n    max-width: 800px;\n    margin: 0 auto;\n    padding: 24px;\n    background-color: var(--white);\n    border-radius: 12px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  }\n  \n  .video-processing h2 {\n    text-align: center;\n    margin-bottom: 24px;\n    color: var(--primary-color);\n  }\n  \n  .progress-container {\n    margin-bottom: 24px;\n  }\n  \n  .progress-bar {\n    height: 10px;\n    background-color: var(--light-border);\n    border-radius: 5px;\n    overflow: hidden;\n    margin-bottom: 8px;\n  }\n  \n  .progress {\n    height: 100%;\n    background-color: var(--primary-color);\n    transition: width 0.3s ease;\n  }\n  \n  .progress-percentage {\n    text-align: center;\n    font-size: 14px;\n    color: var(--light-text);\n  }\n  \n  .processing-stages {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n  \n  .processing-stage {\n    display: flex;\n    align-items: center;\n    padding: 12px 16px;\n    border-radius: 8px;\n    background-color: var(--background-color);\n  }\n  \n  .processing-stage.completed {\n    background-color: rgba(76, 175, 80, 0.1);\n  }\n  \n  .processing-stage.current {\n    background-color: var(--primary-light);\n    border-left: 4px solid var(--primary-color);\n  }\n  \n  .stage-indicator {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 16px;\n    font-size: 14px;\n  }\n  \n  .processing-stage.completed .stage-indicator {\n    background-color: var(--status-green);\n    color: var(--white);\n  }\n  \n  .processing-stage.current .stage-indicator {\n    background-color: var(--primary-color);\n    color: var(--white);\n  }\n  \n  .stage-name {\n    font-size: 16px;\n    font-weight: 500;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
